import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import {
  FaWater,
  FaCogs,
  FaBolt,
  FaIndustry,
  FaTools,
  FaSprayCan,
} from "react-icons/fa";

const Range = () => {

  const iconProducts = [
    {
      title: "Water Pumps",
      desc: "High-performance pumps suitable for residential and industrial water supply.",
      icon: <FaWater />,
    },
    {
      title: "Electric Motors",
      desc: "Energy-efficient motors available in multiple capacities and applications.",
      icon: <FaCogs />,
    },
    {
      title: "Electrical Cables",
      desc: "ISI marked cables ensuring safe and reliable electrical connections.",
      icon: <FaBolt />,
    },
    {
      title: "Casting Pipes",
      desc: "Durable casting pipes designed for heavy-duty industrial usage.",
      icon: <FaIndustry />,
    },
    {
      title: "PVC Pipes",
      desc: "Strong and long-lasting PVC pipes for plumbing and water distribution.",
      icon: <FaTools />,
    },
    {
      title: "Sprinkler Pipes",
      desc: "Efficient sprinkler pipes ideal for irrigation and agricultural needs.",
      icon: <FaSprayCan />,
    },
  ];

  
  const imageProducts = [
    {
      title: "OPENWELL Submersible",
      img: "https://5.imimg.com/data5/SU/UA/GLADMIN-2/submersible-pump-250x250.jpg",
      qualities: ["High Efficiency", "Long Life", "Low Maintenance"],
    },
    {
      title: "4RF/4MF",
      img: "https://5.imimg.com/data5/SELLER/Default/2021/2/XV/ST/OU/761511/v6-submersible-pump.jpg",
      qualities: ["Energy Saving", "Heavy Duty", "Smooth Performance"],
    },
    {
      title: "5MF",
      img: "https://5.imimg.com/data5/SELLER/Default/2023/5/307822646/IV/GU/MW/189226788/varuna-submersible-pump-set-250x250.jpg",
      qualities: ["ISI Marked", "Fire Resistant", "High Conductivity"],
    },
    {
      title: "6RF",
      img: "https://5.imimg.com/data5/SELLER/Default/2024/10/459014604/CK/VJ/BI/11661608/water-borewell-drilling-service-500x500.png",
      qualities: ["Strong Build", "Corrosion Resistant", "Industrial Grade"],
    },
    {
      title: "6MF",
      img: "https://5.imimg.com/data5/QI/FB/MY-43150313/v6-borewell-submersible-pump-500x500.jpg",
      qualities: ["Leak Proof", "Light Weight", "Easy Installation"],
    },
    {
      title: "7MF",
      img: "https://5.imimg.com/data5/SELLER/Default/2022/3/VD/WW/WB/466806/v7-submersible-pumpset.jpg",
      qualities: ["Uniform Water Flow", "Weather Resistant", "Eco Friendly"],
    },
    {
      title: "8MFC",
      img: "https://www.bestomart.com/cdn/shop/products/1000122460_grande.jpg?v=1680258978",
      qualities: ["High Pressure", "Silent Operation", "Durable Design"],
    },
    {
      title: "8MF",
      img: "https://5.imimg.com/data5/SELLER/Default/2025/1/484109466/UL/RB/ZV/60222718/varuna-v8-water-filled-submersible-pumpsets.jpg",
      qualities: ["Rust Resistant", "High Strength", "Long Lasting"],
    },
  ];

  return (
    <>
      <Header />

      {/* BANNER */}
      <section
        className="d-flex align-items-center justify-content-center text-center"
        style={{
          minHeight: "60vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('https://plus.unsplash.com/premium_photo-1661373713949-510c1f0af83f?q=80&w=1471&auto=format&fit=crop')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container text-white">
          <h1 className="fw-bold display-5 mb-3">Our Product Range</h1>
          <div className="d-inline-flex bg-dark bg-opacity-50 px-3 py-2 rounded">
            <span className="me-2">Home</span>
            <span className="text-warning">Our Range</span>
          </div>
        </div>
      </section>

      {/* ICON PRODUCTS */}
      <section className="container py-5">
        {/* <h2 className="fw-bold text-center mb-4">Our Products</h2> */}

        <div className="row g-4">
          {iconProducts.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card h-100 text-center p-4 shadow-sm">
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    background: "#e9f1ff",
                    color: "#0d6efd",
                    fontSize: "24px",
                  }}
                >
                  {item.icon}
                </div>

                <h5 className="fw-bold mb-2">{item.title}</h5>
                <p className="text-muted small mb-0">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* IMAGE PRODUCTS */}
      <section className="container py-5">
        <h2 className="fw-bold text-center mb-4">Product Qualities</h2>

        <div className="row g-4">
          {imageProducts.map((item, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <div className="card h-100 shadow-sm">
                <img
                  src={item.img}
                  alt={item.title}
                  className="card-img-top"
                  style={{ height: "180px", objectFit: "cover" }}
                />

                <div className="card-body text-center">
                  <h5 className="fw-bold mb-3">{item.title}</h5>

                  <ul className="list-unstyled small text-muted mb-0">
                    {item.qualities.map((q, i) => (
                      <li key={i}>✔ {q}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Range;
